<template>
  <div id="text">

    <article class="message">
      <div class="message-body">
        <div class="title is-5">Bar Chart - Multiples</div>
        <div class="text">These bar charts, or small multiples, show the aggregate of <em>methods</em> (scaled 1-5, from transparent to opaque); <em>aesthetics</em>, or language/visuals used (scaled 1-5, from impartial to sensational), and <em>pragmatics</em>, or sphere of impact (scaled 1-5, from public to private), across a range of investigations, within a range of time-scales.</div>
        <div class="text content">
          <ul>
            <li>The first (top-left) is concerned with the aggregate of investigations in the year 2006</li>
            <li>The second (top-right) is concerned with the aggregate of investigations in the year 2009</li>
            <li>The third (middle-left) is concerned with the aggregate of investigations in the year 2017</li>
            <li>The fourth (middle-right) is concerned with the aggregate of investigations in the year 2019</li>
            <li>The fifth (bottom-left) is concerned with the aggregate of investigations between the years 2004 and 2009</li>
            <li>The sixth (bottom-right) is concerned with the aggregate of investigations between the years 2013 and 2019</li>
          </ul>
        </div>
        <div class="text">These charts allow the viewer to better explore how the nature of British investigative journalism may have changed across a range of timeframes.</div>
        <div class="text">It is proposed that interactive text boxes containing the details of each investigation will arise in mouse-over, and that further interactive materials (including bespoke videos and learning materials, concerning a top 10 canon in the field) may be made available.</div>
      </div>
    </article>

      <div class="columns">
        <div class="column">
          <div class="column"><BarOne2006 :mydata="mydata"></BarOne2006></div>
          <div class="column"><BarThree2017 :mydata="mydata"></BarThree2017></div>

        </div>
        <div class="column">
          <div class="column"><BarTwo2009 :mydata="mydata"></BarTwo2009></div>
          <div class="column"><BarFour2018 :mydata="mydata"></BarFour2018></div>
        </div>
      </div>
      <div class="columns">
        <div class="column"><BarFive2000To2009 :mydata="mydata"></BarFive2000To2009></div>
        <div class="column"><BarSix2010To2020 :mydata="mydata"></BarSix2010To2020></div>
      </div>


    <div class="content">
      <strong>Variables:</strong>
      <ul>
        <li>Methods used (scaled 1-5; from transparent to opaque)</li>
        <li>Pragmatics involved (scaled 1-5; from public to private)</li>
        <li>Aesthetics (scaled 1-5; from impartial to sensational)</li>
      </ul>
    </div>


  </div>
</template>

<script>

    import { GChart } from "vue-google-charts";
    import BarOne2006 from "./BarOne2006";
    import BarTwo2009 from "./BarTwo2009";
    import BarThree2017 from "./BarThree2017";
    import BarFour2018 from "./BarFour2018";
    import BarFive2000To2009 from "./BarFive2000To2009";
    import BarSix2010To2020 from "./BarSix2010To2020";

    export default {
        name: "BarMultiples",
        props: {
            mydata : []
        },
        components: {
            GChart,
            BarOne2006,
            BarTwo2009,
            BarThree2017,
            BarFour2018,
            BarFive2000To2009,
            BarSix2010To2020
        },
        mounted()  {
          console.log('bar multiples loaded');
        }
    }
</script>

<style scoped>


  #text {
    width: 100%;
  }

  .text {
    padding: 5px 0;
  }

  .content {
    margin-bottom: 5px;
  }
  em {
    font-weight: 500
  }

</style>
